import { render, staticRenderFns } from "./FirstSteps.vue?vue&type=template&id=4430f7a2&lang=pug&"
import script from "./FirstSteps.vue?vue&type=script&lang=js&"
export * from "./FirstSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports